module.exports = __webpack_public_path__ + "img/platzhalter.ccb0f12a.png";